export * from './projekt-stati-list.component';
export * from './projekt-stati-list.component.module';